
















































import TableComp from '@/components/Common/TableComp.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'insuranceCommissionList',
  components: {
    TableComp,
  }
})
export default class extends Vue {
  @Prop() private datas!: any;
  @Prop({ default: false }) private markedAmountRed!: boolean;
  @Prop({ default: true }) private isSelectionTable!: boolean;

  public setTableSelection(rows: any) {
    const tableRef = (this.$refs.tableCompRef as any).getTableRef();
    rows.forEach((row: any) => {
      tableRef.toggleRowSelection(row);
    });
  }

  public handleSelect({ selection }: any) {
    this.$emit('select', selection);
  }

}
